export interface CreateEntityPayload {
  countryCode: string;
  tenantCode: string;
  entityCode?: string;
}

export interface GetEntityPayload {
  forTenantCode: string;
  entityCode?: string;
  countryCode: string;
}

export interface SearchEntityPayload {
  limit: number;
  offset: number;
  searchStr: string;
  filters: any[];
  countryCode: string;
  deleted: string;
  forTenantCode: string;
  actionStatus: string;
  advanceFilters?: any;
  tableViewCode?: string;
  defaultSortColumn?: string;
  defaultSortType?: string;
}



export interface ViewCode {
  DEFAULT_TABLE_VIEW: string;
  DEFAULT_TABLE_VEHICLE_ASSIGNMENT_VIEW: string;
  DEFAULT_TABLE_DRIVER_ASSIGNMENT_VIEW: string;
  DEFAULT_FILTER_VIEW: string;
  ADD_EDIT_VIEW: string;
  DETAIL_VIEW: string;
  BULK_UPDATE_VIEW: string;
  EXCEL_IMPORT_VIEW: string;
  ADVANCED_FILTER_VIEW: string;
  DRIVER_ASSIGN_DUTY_STATUS_VIEW: string;
  DRIVER_DETAILS_ON_BOOKING_VIEW: string;
  VEHICLE_DETAILS_ON_BOOKING_VIEW: string;
  DRIVER_DETAILS_ON_DISPATCH_VIEW: string;
  GENERAL_SETTINGS_VIEW: string;
  TIME_SETTINGS_VIEW: string;
  SECURITY_SETTINGS_VIEW: string;
  EXPORT_ACCOUNT_DATA_SETTINGS: string;
  BOOKING_HISTORY_VIEW: string;
  AUTOCOMPLETE_VIEW: string;
  SHIFT_CALENDAR_DRIVER_LIST_VIEW: string;
  DRIVER_LIST_FOR_GROUP_VIEW: string;
}


export interface EntityList {
  limit?: number;
  offset?: number;
  searchStr?: string;
  eventCode?: string;
  defaultSortColumn?: string;
  defaultSortType?: string;
  filters?: Filter[];
  forTenantCode: string;
  countryCode?: string;
  deleted?: string;
  actionStatus?: string;
  status?: any;
  userName?: string;
  tagIds?: string[];
  tableViewCode?: string;
  advanceFilters?: AdvanceFilter[];
  languageCode?: string;
  viewCode?: string;
  fieldNotExistFilter?: string[];
  protocolIds?: any;
  data?: any[];
  statusCode?: any;
  startDate?: any;
  endDate?: any;
  entityCode?: any[];
}

export interface Filter {
  attributeCode?: any,
  attributeId?: any;
  attributeValue: AttributeValue;
}

export interface AdvanceFilter {
  attributeId?: any;
  fromValue?: any,
  toValue?: any,
  comparisonOperator: string;
}

export interface AttributeValue {
}


export interface EntityCount {
  forTenantCode: string,
  entityCode?: string
}

export interface EntityCountsResponse {
  tenantId: string;
  entityCode: string;
  counts: Counts;
}

export interface Counts {
    ALL: number;
    DELETED: number;
    [key: string]: number;
}


export interface ActionStatusUpdate {
  forTenantCode: string;
  entityCode: string;
  actionStatus: string;

}

export enum EntityType {
  sponsor = 'Sponsor',
  product = 'Product',
  protocol = 'Protocol',
  patient = 'Patient',
  site = 'Site',
  user_detail = 'User Detail',
  protocol_user = 'Protocol User',
  protocol_patient = 'Protocol Patient',
  change_review = 'Change Review',
  manage_users = 'Manage Users',
  order = 'Order',
  site_delivery_address = 'Site Delivery Address',
  site_user = 'Site User',
  protocol_product = 'Protocol Product',
  protocol_site = 'Protocol Site',
  protocol_sponsor = 'Protocol Sponsor',
  protocol_purchase_order = 'Protocol Purchase Order',
  protocol_activity = 'Protocol Activity',
  manage_user = 'Manage User',
  protocol_order = 'Protocol Order', 
  order_product = 'Order Product',
}